var map = {
	"./Union.svg": 84986,
	"./activation-limit.svg": 51066,
	"./application-record.svg": 65799,
	"./back.svg": 10611,
	"./borrow-money.svg": 98660,
	"./bulb.svg": 83088,
	"./check-circle.svg": 89229,
	"./close.svg": 19048,
	"./fail-warn.svg": 96495,
	"./gold.svg": 51299,
	"./home.svg": 57407,
	"./icon-warn.svg": 15212,
	"./immediate-withdrawal.svg": 33840,
	"./input-phone.svg": 58799,
	"./jufu-haier-text-logo.svg": 92067,
	"./jufu-jurongyi-text-logo.svg": 29675,
	"./jufu-text-logo.svg": 54824,
	"./lightning.svg": 74988,
	"./lock.svg": 58471,
	"./money-collect.svg": 4155,
	"./my.svg": 1121,
	"./personal-data.svg": 2304,
	"./purse.svg": 6550,
	"./rocket.svg": 38218,
	"./safety.svg": 46347,
	"./sound.svg": 49878,
	"./xiangbei-close.svg": 64711,
	"./xiangbei-handshake.svg": 92921,
	"./xiangbei-phone.svg": 73788,
	"./xiangbei-user.svg": 6815,
	"./youqianqianbao-text.svg": 50099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60401;